import React, {Component} from "react";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {Col, Row} from "reactstrap";
import {toast} from "react-toastify";

import {getEntity} from "../../../services/entity/entity-service";
import {getActiveGameSessionId} from "../../../services/player/player-service";
import {playActiveSession} from "../../../services/game-session/game-session-service";

import FormSection from "../../components/form-section/form-section";
import LoadingSpinner from "../../components/loading-spinner/loading-spinner"
import PlayerActivitiesSummaryCard from "../../components/player-activities-summary-card/player-activities-summary-card"
import PlayerCard from "../../components/player-card/player-card";
//import SupinationPronationSection from "../../components/player-overview-charts/supination-pronation-section.js";
import PlayerROMSection from "../../components/player-overview-charts/rom-data-section.js";
import PlayerDashboardButtons from "../../components/player-dashboard-buttons/player-dashboard-buttons";
import PlayerFavoriteGameCard from "../../components/player-favorite-game-card/player-favorite-game-card";
import PlayerFavoritePositionCard from "../../components/player-favorite-position-card/player-favorite-position-card";
import PlayerOverviewMinutesPlayedChart
    from "../../components/player-overview-charts/player-overview-minutes-played-chart";

import {getGameSession} from "../../../modules/game_session";
import {getGames} from "../../../modules/system/game";
import {updatePlayer, getSpecificPlayer, resetSpecificPlayer, archivePlayer} from "../../../modules/player";
import {
    actions,
    getPlayerAngleSectionData,
    getPlayerGameResultsForSummary,
    getPlayerMinutesPlayed,
    getPlayerROMData,    
    getPlayerFavoriteGame,
    getPlayerFavoritePosition
} from "../../../modules/result";
import {getPositions} from "../../../modules/system/position";
import {getSkills} from "../../../modules/system/skill";
import {parseQuery} from "../../../transformations/queryString";
import {resultsActions} from "../../../modules/views/result_view";
import {setPageTitle} from "../../../modules/application/pages";
import { withWhiteLabelContext } from "react-whitelabel";

import "./player-dashboard.css";

class PlayerDashboard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            displayName: null,
            therapistId: null,
            therapistPlayers: [],
            player: {},
            results: [],
            activities: [],
            minutes_played: [],
            activeGameSession: {},
            shouldSetPlayer: true, 
            favoriteGameData: false,
            favoritePositionData: false
        };

        this.archivePlayer = this.archivePlayer.bind(this);
        this.deletePlayer = this.deletePlayer.bind(this);
        this.onClickPlayActiveSession = playActiveSession.bind(this);
        this.setPlayer = this.setPlayer.bind(this);
    }

    componentWillMount() {
        const {label} = this.props;
        this.props.dispatch(resetSpecificPlayer());
        this.setState({shouldSetPlayer: true});
        this.props.dispatch(getGames([]));
        this.props.dispatch(getPositions([{platform_id:`${label.platform.platform_id}`}]));
        this.props.dispatch(getSkills());
    }

    componentDidUpdate() {
      if (this.props.specificPlayer && this.state.shouldSetPlayer) {
        this.setPlayer(this.props.specificPlayer);
        this.setState({ shouldSetPlayer: false});
      }
    }

    componentDidMount() {
        const {token} = this.props;
        this.props.dispatch(getSpecificPlayer(this.props.match.params.id, token));
        const queryString = parseQuery(window.location);

        if (queryString && queryString.message) {
            const message = queryString.message;

            toast.success(unescape(message), {
                position: toast.POSITION.TOP_CENTER
            });
        }
    }

    async setPlayer(player) {
        const {dispatch, token} = this.props;
        // non-entity operations...
        await this.props.dispatch(this.props.resetResultViewState());
        await this.props.dispatch(this.props.startGettingMinutesPlayed());
        await this.props.dispatch(getPlayerMinutesPlayed(this.props.match.params.id, token));
        await this.props.dispatch(getPlayerAngleSectionData(this.props.match.params.id, token));
        await this.props.dispatch(getPlayerROMData(this.props.match.params.id, token));

        this.props.dispatch(setPageTitle(player.name));

        let results = await getPlayerGameResultsForSummary(player.id, token);
        let favoriteGameData = await getPlayerFavoriteGame(player.id, token);
        let favoritePositionData = await getPlayerFavoritePosition(player.id, token);

        this.setState({favoriteGameData: favoriteGameData.data.data, favoritePositionData: favoritePositionData.data.data});

        results = results.data.results;
        //const results = [];
        //const activities = await getEntity(dispatch, getPlayerGameSessionActivities([{"player": player.id}]), true);

        let activeGameSession = {};
        const activeGameSessionId = getActiveGameSessionId(player);

        if (activeGameSessionId) {
            activeGameSession = await getEntity(dispatch, getGameSession(activeGameSessionId));
        }

        this.setState({activeGameSession, player, results});
    }

    render() {
        let {user} = this.props;


        if (user.limited) {
            return (
                <div className='restore_limited_message'>This Page is not available on RESTORE Limited</div>
            );
        }
        else {
            return (
                <div className="px-1"><FormSection component={this.playerDashboard()}/></div>
            );    
        }
        
    }


    playerDashboard() {
        const {player} = this.state;
        const playerLoaded = player && player.id;

        return <div className="mp-0 container-fluid">
            {playerLoaded && (
                <PlayerDashboardButtons player={player} activePage="overview" isTherapistRole={this.props.isTherapistRole} />
                )}
            {!playerLoaded && <LoadingSpinner/>}
            {playerLoaded && this._playerDashboard()}
        </div>;
    }


    _playerDashboard() {
        const {games, skills, token, currentUserId, specificPlayer, user} = this.props;
        const {activeGameSession, player, results, favoriteGameData, favoritePositionData} = this.state;
        if (!specificPlayer) {
          return;
        }

        let isOwner = user.currentUserId === player.owner;

        return <div className="mp-0">
            <Row className="mx-1 my-1 p-0 text-left">
                <Col md="12" className="p-0" key={player.id}>
                    <PlayerCard player={specificPlayer}
                                isOwner={isOwner}
                                results={results}
                                skills={skills}
                                isExtended={true}
                                archivePlayer={this.archivePlayer}
                                deletePlayer={this.deletePlayer}
                                onClickPlayActiveSession={() => {
                                    this.onClickPlayActiveSession(specificPlayer, token, currentUserId, null, null, true)
                                }}
                                token={this.props.token}
                                isReady={(results && results.length > 0) || activeGameSession}
                                activeGameSession={activeGameSession}
                    />
                </Col>
            </Row>
            <Row className="m-1 p-0">
                <Col md="12" className="my-1 p-0">
                    <FormSection
                        sectionLabel="Playing Statistics"
                        component={
                            <div className="mp-0 container-fluid">
                                <Row className="ml-1 mr-2 my-1">
                                    <Col md={6} className="ml-0 mr-1 my-0 p-0 pointer"
                                         onClick={() => this.props.history.push(`/player/${player.id}/activities`)}>
                                        <PlayerOverviewMinutesPlayedChart
                                            minutes_played_data={this.props.minutes_played_data}/>
                                    </Col>
                                    <Col className="ml-0 mr-1 my-0 p-0">
                                        <PlayerFavoriteGameCard favorite_game_data={favoriteGameData}  games={games}/>
                                    </Col>
                                    <Col className="ml-0 mr-1 my-0 p-0">
                                        <PlayerFavoritePositionCard favorite_position_data={favoritePositionData}/>
                                    </Col>
                                </Row>
                                <Row className="ml-1 mr-2 my-1">
                                  <Col md={6} className="mx-1 my-0 pl-0 pr-2 py-0 pointer"
                                       onClick={() => this.props.history.push(`/player/${player.id}/sessions`)}>
                                      <PlayerActivitiesSummaryCard results={results}/>
                                  </Col>
                                  <Col className="mp-0 container-fluid card shadow">
                                    {
                                      this.props.rom_data && <PlayerROMSection rom_data={this.props.rom_data} />
                                    }
                                  </Col>
                                  {/* <Col md={12} className="mx-1 my-0 pl-0 pr-2 py-0 pointer">
                                    {
                                        this.props.angles_data && <SupinationPronationSection angle_data={this.props.angles_data} />
                                    }

                                  </Col> */}
                                </Row>
                            </div>
                        }
                    />
                </Col>
            </Row>
        </div>;
    }

    async archivePlayer(playerId, fullArchive) {
        let {token} = this.props;
        if (typeof fullArchive === "undefined") {
            fullArchive  = false;
        }

        await archivePlayer(playerId, fullArchive, token);
        //const playerData = {is_archived: true};
        //await getEntity(this.props.dispatch, updatePlayer(playerId, playerData));
        window.location = `/therapistDashboard/?message=Archived player ${this.state.player.name}`;
    }

    async deletePlayer(playerId) {        
        const playerData = {is_deleted: true};
        await getEntity(this.props.dispatch, updatePlayer(playerId, playerData));
        window.location = `/therapistDashboard?message=Deleted player ${this.state.player.name}`;
    }
}

const withState = connect(state => {
    const {user, game, position, skill, result, player} = state;

    return {
        user: user,
        isTherapistRole: user.isTherapistRole,
        currentUserId: user.currentUserId,
        token: user.token,
        games: game.games,
        skills: skill.skills,
        positions: position.positions,
        minutes_played_data: result.minutes_played,
        rom_data: result.rom_data,        
        angles_data: result.angle_data,
        startGettingAngleData: actions.startGettingAngleData,
        updateAngleData: actions.updateAngleData,
        startGettingMinutesPlayed: resultsActions.startGettingMinutesPlayedData,
        resetResultViewState: resultsActions.resetState,
        specificPlayer: player.specific_player
    };
});
export default withWhiteLabelContext(withRouter(withState(PlayerDashboard)));



// WEBPACK FOOTER //
// ./src/components/containers/player-dashboard/player-dashboard.js